<template>
    <div>
        <loading :active.sync="isLoading"
                 :is-full-page="fullPage"
                 color="#00F">
        </loading>

        <b-button v-if="proposal_status == 9" class="mt-3" variant="success" block v-on:click="approveProposal()">
            Approve Proposal And Get Customer Signature Now
        </b-button>
        <b-button v-if="proposal_status == 9" class="mt-3" variant="warning" block v-on:click="rejectProposal()">Reject
            Proposal
        </b-button>
<!--        <b-button v-if="proposal_status == 8" class="mt-2" variant="primary" block v-on:click="transferToCustomer()">-->
<!--            Transfer To Customer-->
<!--        </b-button>-->
        <b-button v-if="proposal_status == 10 || proposal_status == 1 || proposal_status == 8" class="mt-2"
                  variant="success" block v-on:click="sendCustomerSignature()">Get Customer Signature Now
        </b-button>
        <b-button v-if="proposal_status == 1 || proposal_status == 8" class="mt-2" variant="success" block v-on:click="sendLinkToCustomerFinal()">
            Get Customer Confirmation
        </b-button>
        <br>
    </div>
</template>

<script>
    import {mapState, mapActions} from "vuex";

    export default {
        data: () => {
            return {
                isLoading: false,
                fullPage: true
            };
        },
        computed: {
            ...mapState("proposal", [
                "proposal_id",
                "proposal_status"
            ]),
        },
        mounted() {

        },
        methods: {
            ...mapActions("proposal", [
                "getCustomerSignature",
                "approveProposalAgent",
                "getProposalData",
                "transferProposalToCustomer",
                "sendCustomerLink",
                "saveProposalData",
                "rejectProposalAgent",
                "validateFinal",
                "sendCustomerLinkFinal"
            ]),
            sendCustomerSignature() {
                this.isLoading = true;
                this.validateFinal().then((response) => {
                    if (response.data.errors) {
                        //this.$refs.all_form_wizard.setErrors(response.data.errors);
                        this.isLoading = false;
                        this.$snotify
                            .error(response.data.errors.message, "", {
                                position: "centerTop",
                            });

                    } else {
                        let data = {
                            proposal_id: this.proposal_id
                        };
                        this.getCustomerSignature(data).then((response) => {
                            if (!response.error) {
                                this.$snotify
                                    .success(response.data.message, "", {
                                        position: "centerTop",
                                    }).on("destroyed", () => {
                                    this.$router.push({
                                        name: "ProposalList"
                                    })
                                });
                            }
                            this.isLoading = false;
                        });
                    }
                });


            },
            rejectProposal() {
                this.isLoading = true;
                let data = {
                    proposal_id: this.proposal_id
                };
                this.rejectProposalAgent(data).then((response) => {
                    if (!response.error) {
                        this.$snotify
                            .success(response.data.message, "", {
                                position: "centerTop",
                            }).on("destroyed", () => {
                            this.$router.push({
                                name: "ProposalList"
                            });
                        });
                    }
                    this.isLoading = false;
                });
            },
            approveProposal() {
                this.isLoading = true;
                let data = {
                    proposal_id: this.proposal_id
                };
                this.approveProposalAgent(data).then((response) => {
                    if (!response.error) {
                        this.sendCustomerSignature();
                    }
                });
            },
            transferToCustomer() {
                this.isLoading = true;
                let data = {
                    proposal_id: this.proposal_id
                };
                this.transferProposalToCustomer(data).then((response) => {
                    if (!response.data.errors) {
                        this.$snotify
                            .success(response.data.message, "", {
                                position: "centerTop",
                            }).on("destroyed", () => {
                            this.$router.push({
                                name: "ProposalList"
                            });
                        });
                    }else{
                      this.$snotify
                          .error(response.data.errors.message, "", {
                            position: "centerTop",
                          });
                    }
                    this.isLoading = false;
                });
            },
            sendLinkToCustomer() {
                this.isLoading = true;
                const data = {
                    status: 2,
                    proposal_id: this.proposal_id
                };
                this.saveProposalData(data).then((response) => {
                    if (!response.error) {
                        const smsData = {
                            proposal_id: this.proposal_id
                        };
                        this.sendCustomerLink(smsData).then((response) => {
                            if (!response.error) {
                                this.$snotify
                                    .success(response.data.message, "", {
                                        position: "centerTop",
                                    }).on("destroyed", () => {
                                    this.$router.push({
                                        name: "ProposalList"
                                    })
                                });
                            }
                            this.isLoading = false;
                        });
                    }

                });
            },
            sendLinkToCustomerFinal() {
              this.isLoading = true;
              const data = {
                status: 2,
                proposal_id: this.proposal_id
              };
              this.saveProposalData(data).then((response) => {
                if (!response.error) {
                  const smsData = {
                    proposal_id: this.proposal_id
                  };
                  this.sendCustomerLinkFinal(smsData).then((response) => {
                    if (!response.error) {
                      this.$snotify
                          .success(response.data.message, "", {
                            position: "centerTop",
                          }).on("destroyed", () => {
                        this.$router.push({
                          name: "ProposalList"
                        })
                      });
                    }
                    this.isLoading = false;
                  });
                }

              });
            }


        }

    }
</script>

<style scoped>


</style>